import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatAsGermanDate } from '~/functions/helpers';
import { getImpactCarryWeightedSummary, hasCarryRemarks, shouldRenderMetricAssignment } from '~/functions/impact-carry-kpi';
import { impactResultCardEditPath } from '~/functions/impact-result-card-edit';
import { getCarryScalarChangedFieldKeys } from '~/functions/review-snapshot-diff';
import { useListEvidenceLinksQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactCarryResults',
  props: {
    impact: null,
    ventureId: null,
    readOnly: {
      type: Boolean
    },
    exportLayout: {
      type: Boolean
    },
    evidenceLinks: null,
    compareImpact: null,
    compareToLive: {
      type: Boolean
    },
    compareReviewTimeIsDisplay: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var exportLayout = computed(function () {
      return props.exportLayout === true;
    });
    var sectionPaddingClass = computed(function () {
      return exportLayout.value ? 'pa-4' : 'pa-4 pa-md-5';
    });
    var impact = computed(function () {
      return props.impact;
    });
    var editPath = computed(function () {
      return impactResultCardEditPath(props.ventureId, impact.value);
    });
    var allRenderableAssignments = computed(function () {
      var _impact$value$metricA, _impact$value;
      return ((_impact$value$metricA = (_impact$value = impact.value) === null || _impact$value === void 0 ? void 0 : _impact$value.metricAssignments) !== null && _impact$value$metricA !== void 0 ? _impact$value$metricA : []).filter(shouldRenderMetricAssignment);
    });
    var showKpiWeights = computed(function () {
      return allRenderableAssignments.value.length > 1;
    });
    var weightedSummary = computed(function () {
      return getImpactCarryWeightedSummary(allRenderableAssignments.value);
    });
    var weightedPerformanceLabel = computed(function () {
      var score = weightedSummary.value.weightedPerformancePercent;
      if (score === null || score === undefined) return '—';
      return "".concat(score, "%");
    });
    var weightedProgressPercentValue = computed(function () {
      var score = weightedSummary.value.weightedPerformancePercent;
      if (score === null || score === undefined) return 0;
      return score;
    });
    var companyOnTrack = computed(function () {
      var score = weightedSummary.value.weightedPerformancePercent;
      if (score === null || score === undefined) return null;
      return score >= 100;
    });
    var latestReportedLabel = computed(function () {
      var _impact$value2, _impact$value3;
      var period = weightedSummary.value.latestReportedPeriod;
      if (!period) return null;
      var start = (_impact$value2 = impact.value) === null || _impact$value2 === void 0 ? void 0 : _impact$value2.startingYear;
      var years = (_impact$value3 = impact.value) === null || _impact$value3 === void 0 ? void 0 : _impact$value3.durationYears;
      if (!start || !years) return null;
      var index = Number(period) - Number(start) + 1;
      return String(proxy.$t('actualsReportedThrough', {
        year: period,
        index: index,
        total: years
      }));
    });
    var showGlobalRemarks = computed(function () {
      var _impact$value4;
      return hasCarryRemarks((_impact$value4 = impact.value) === null || _impact$value4 === void 0 ? void 0 : _impact$value4.carryRemarks);
    });
    var carryRemarksText = computed(function () {
      var _impact$value5;
      if (!showGlobalRemarks.value) return null;
      // `whitespace-pre-wrap` preserves literal tabs/spaces the user typed at the
      // start of any line (not just the start of the whole field), so strip
      // leading indentation per line, not just the outer edges of the string.
      return String((_impact$value5 = impact.value) === null || _impact$value5 === void 0 ? void 0 : _impact$value5.carryRemarks).split('\n').map(function (line) {
        return line.replace(/^[ \t]+/, '');
      }).join('\n').trim();
    });
    var reviewTimeImpact = computed(function () {
      if (!props.compareToLive || !props.compareImpact) return null;
      return props.compareReviewTimeIsDisplay ? impact.value : props.compareImpact;
    });
    var currentImpact = computed(function () {
      if (!props.compareToLive || !props.compareImpact) return null;
      return props.compareReviewTimeIsDisplay ? props.compareImpact : impact.value;
    });
    var reviewTimeCarryRemarks = computed(function () {
      var _reviewTimeImpact$val, _reviewTimeImpact$val2;
      var text = (_reviewTimeImpact$val = reviewTimeImpact.value) === null || _reviewTimeImpact$val === void 0 ? void 0 : (_reviewTimeImpact$val2 = _reviewTimeImpact$val.carryRemarks) === null || _reviewTimeImpact$val2 === void 0 ? void 0 : _reviewTimeImpact$val2.trim();
      return text || null;
    });
    var currentCarryRemarks = computed(function () {
      var _currentImpact$value, _currentImpact$value$;
      var text = (_currentImpact$value = currentImpact.value) === null || _currentImpact$value === void 0 ? void 0 : (_currentImpact$value$ = _currentImpact$value.carryRemarks) === null || _currentImpact$value$ === void 0 ? void 0 : _currentImpact$value$.trim();
      return text || null;
    });
    var showRemarksDiff = computed(function () {
      return props.compareToLive === true && reviewTimeImpact.value != null && currentImpact.value != null && getCarryScalarChangedFieldKeys(reviewTimeImpact.value, currentImpact.value).has('carryRemarks');
    });
    function compareAssignmentFor(assignmentId) {
      var _props$compareImpact$, _props$compareImpact$2;
      if (!props.compareToLive || !props.compareImpact || assignmentId == null) return null;
      return (_props$compareImpact$ = (_props$compareImpact$2 = props.compareImpact.metricAssignments) === null || _props$compareImpact$2 === void 0 ? void 0 : _props$compareImpact$2.find(function (assignment) {
        return assignment.id === assignmentId;
      })) !== null && _props$compareImpact$ !== void 0 ? _props$compareImpact$ : null;
    }
    var initialInvestmentLabel = computed(function () {
      var _impact$value6;
      var initialInvestmentDate = (_impact$value6 = impact.value) === null || _impact$value6 === void 0 ? void 0 : _impact$value6.initialInvestmentDate;
      if (!initialInvestmentDate) return null;
      var formatted = formatAsGermanDate(String(initialInvestmentDate));
      if (!formatted) return null;
      return String(proxy.$t('initialInvestment', {
        date: formatted
      }));
    });
    var updatedOnLabel = computed(function () {
      var _impact$value7;
      var submitDate = (_impact$value7 = impact.value) === null || _impact$value7 === void 0 ? void 0 : _impact$value7.submitDate;
      if (!submitDate) return null;
      var formatted = formatAsGermanDate(String(submitDate));
      if (!formatted) return null;
      return String(proxy.$t('updatedOn', {
        date: formatted
      }));
    });
    var periodRangeLabel = computed(function () {
      var _impact$value8, _impact$value9;
      var start = (_impact$value8 = impact.value) === null || _impact$value8 === void 0 ? void 0 : _impact$value8.startingYear;
      var years = (_impact$value9 = impact.value) === null || _impact$value9 === void 0 ? void 0 : _impact$value9.durationYears;
      if (!start || !years) return null;
      var end = start + years - 1;
      return String(proxy.$t('periodRange', {
        start: start,
        end: end,
        years: years
      }));
    });
    var onTrackLabel = computed(function () {
      return String(proxy.$t('statusOnTrack'));
    });
    var behindLabel = computed(function () {
      return String(proxy.$t('statusBehind'));
    });
    var impactId = computed(function () {
      var _impact$value10;
      return (_impact$value10 = impact.value) === null || _impact$value10 === void 0 ? void 0 : _impact$value10.id;
    });
    var evidenceVariables = computed(function () {
      return {
        filters: {
          accountId: props.ventureId,
          entityIntIds: impactId.value ? [impactId.value] : [],
          type: 'impact'
        },
        limit: 1000,
        offset: 0
      };
    });
    var useLiveEvidenceLinks = computed(function () {
      return props.evidenceLinks === undefined;
    });
    var _useListEvidenceLinks = useListEvidenceLinksQuery(evidenceVariables, computed(function () {
        return {
          enabled: useLiveEvidenceLinks.value && typeof impactId.value === 'number'
        };
      })),
      evidenceResult = _useListEvidenceLinks.result;
    var impactEvidenceLinks = computed(function () {
      var _evidenceResult$value, _evidenceResult$value2;
      if (props.evidenceLinks !== undefined) {
        var _props$evidenceLinks;
        return (_props$evidenceLinks = props.evidenceLinks) !== null && _props$evidenceLinks !== void 0 ? _props$evidenceLinks : [];
      }
      return (_evidenceResult$value = (_evidenceResult$value2 = evidenceResult.value) === null || _evidenceResult$value2 === void 0 ? void 0 : _evidenceResult$value2.listEvidenceLinks) !== null && _evidenceResult$value !== void 0 ? _evidenceResult$value : [];
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      exportLayout: exportLayout,
      sectionPaddingClass: sectionPaddingClass,
      impact: impact,
      editPath: editPath,
      allRenderableAssignments: allRenderableAssignments,
      showKpiWeights: showKpiWeights,
      weightedSummary: weightedSummary,
      weightedPerformanceLabel: weightedPerformanceLabel,
      weightedProgressPercentValue: weightedProgressPercentValue,
      companyOnTrack: companyOnTrack,
      latestReportedLabel: latestReportedLabel,
      showGlobalRemarks: showGlobalRemarks,
      carryRemarksText: carryRemarksText,
      reviewTimeImpact: reviewTimeImpact,
      currentImpact: currentImpact,
      reviewTimeCarryRemarks: reviewTimeCarryRemarks,
      currentCarryRemarks: currentCarryRemarks,
      showRemarksDiff: showRemarksDiff,
      compareAssignmentFor: compareAssignmentFor,
      initialInvestmentLabel: initialInvestmentLabel,
      updatedOnLabel: updatedOnLabel,
      periodRangeLabel: periodRangeLabel,
      onTrackLabel: onTrackLabel,
      behindLabel: behindLabel,
      impactId: impactId,
      evidenceVariables: evidenceVariables,
      useLiveEvidenceLinks: useLiveEvidenceLinks,
      evidenceResult: evidenceResult,
      impactEvidenceLinks: impactEvidenceLinks
    };
  }
});